<template>
    <div id="features" class="relative w-full mx-auto px-8 py-5 md:py-5 lg:py-5 xl:py-10 xl:pt-20 xl:px-0">
    <div class="bg-orange-500 py-10 w-full">
        <div class="text-white bg-orange-500 px-3 absolute left-0 transform -translate-y-1/2 -translate-x-1/2 font-bold" style="left: 25%;">Health Tip!</div>
        <div
            class="container flex flex-col border-2 pb-5 px-0 border-white rounded-md  items-center justify-between h-full max-w-6xl mx-auto">
            <h2 class="my-5 text-base tracking-tight text-gray-900 font-semibold uppercase">{{ tips[currentTip].title }}
            </h2>
            <h3
                class=" max-w-2xl px-5 mt-2 text-3xl leading-tight text-center text-gray-50 sm:mt-0 sm:px-0 sm:text-xl">
                "{{ tips[currentTip].description }}"</h3>
        </div>
    </div>
</div>

</template>

<script>
import healthTips from '@/assets/json/HealthTips.json'

export default {
    data() {
        return {
            currentTip: 0,
            tips: healthTips.health_tips,
            intervalId: null,
        };
    },
    mounted() {
        this.startAutoSlide();
    },
    beforeUnmount() {
        this.stopAutoSlide();
    },
    methods: {
        nextImage() {
            this.currentTip = (this.currentTip + 1) % this.tips.length;
        },
        prevImage() {
            this.currentTip =
                (this.currentTip + this.tips.length - 1) % this.tips.length;
        },
        startAutoSlide() {
            this.intervalId = setInterval(this.nextImage, 1000*this.tips.length); // Change slide every 3 seconds
        },
        stopAutoSlide() {
            clearInterval(this.intervalId);
        },
    },
};
</script>

<style scoped></style>
